module.exports = __webpack_public_path__ + "files/29d358bcd3a4d30757dddc2f9d23bcff.png";